import React, { useRef } from 'react';
import { Columns } from '@components/Columns';
import {
  StyledSection,
  LeftSectionTextPairing,
  TheAppShapeImage,
  TheMobileImage,
  TheGoldThreadImage,
  StyledAppBody,
  RightSectionWrapper,
  IOSAndroidStyledFlex,
} from './RegistryAppSection.styles';
import { registryPageData } from '@data-ts/pages/registry';
import { Box } from '@components/Box';
import { CTALink } from '@components/CTALink';
import { CloudImage } from '@components/CloudImage';
import { Integrations } from '@static/js/types';

const analytics = require('../../../../static/js/joy');

const registryAppSectionData = registryPageData.registryApp;

interface RegistryAppSectionProps {}

export const RegistryAppSection: React.FC<RegistryAppSectionProps> = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  const onCTAClicked = (e: React.MouseEvent, url: string, name: string) => {
    e.preventDefault();
    analytics.segment.sendTelemetryEvent(`newmarketing.registry${name}Clicked`, { label: name }, undefined, {
      integrations: { [Integrations.Amplitude]: true },
    });
    window.open(url, '_blank');
  };

  return (
    <StyledSection as="section" ref={sectionRef} id="Registry_App" marginTop={[11]} marginBottom={[14, 0]}>
      <StyledAppBody>
        <Columns centered>
          <Columns.Column offset={1} width={5}>
            <LeftSectionTextPairing
              eyebrow={registryAppSectionData.eyebrow}
              eyebrowColor="humana5"
              eyebrowVariant="sectionEyeBrow20"
              eyebrowTagName="h3"
              title={registryAppSectionData.title}
              titleVariant="hed40"
              titleColor="humana5"
              titleTagName="h2"
              body={registryAppSectionData.body}
              bodyVariant="dek20"
              bodyColor="neutra6"
              bodyTagName="p"
            />
            <Box marginTop={[8]} marginBottom={[8, 0]}>
              <IOSAndroidStyledFlex flexDirection={['row']}>
                <CTALink
                  id="playstore"
                  aria-label="Registry Playstore"
                  href="https://itunes.apple.com/app/joy-your-wedding-app/id994411720?mt=8"
                  onClick={e => onCTAClicked(e, 'https://itunes.apple.com/app/joy-your-wedding-app/id994411720?mt=8', 'AppStore')}
                >
                  <CloudImage alt={registryAppSectionData.altTextAppStore} src={'common/buttons/appstorenew.png'} />
                </CTALink>
                <CTALink
                  id="googleplay"
                  aria-label="Registry Googleplay"
                  href="https://play.google.com/store/apps/details?id=com.withjoy.joy"
                  onClick={e => onCTAClicked(e, 'https://play.google.com/store/apps/details?id=com.withjoy.joy', 'GooglePlay')}
                >
                  <CloudImage alt={registryAppSectionData.altTextGooglePlay} src={'common/buttons/google-play-badge.png'} />
                </CTALink>
              </IOSAndroidStyledFlex>
            </Box>
          </Columns.Column>
          <Columns.Column offset={1} width={5}>
            <RightSectionWrapper>
              <TheAppShapeImage src="registry-v2/registry-app/the-app-shape.svg" />
              <TheGoldThreadImage src="registry-v2/registry-app/gold-thread-3.svg" />
              <TheMobileImage src="registry-v2/registry-app/registry-mobile-v3.png" />
            </RightSectionWrapper>
          </Columns.Column>
        </Columns>
      </StyledAppBody>
    </StyledSection>
  );
};
